import ApiHandler from '@/api/base'
import TriggersApiHandler from '@/api/triggers'
import { ALERTS_LIMIT, ALERTS_TYPES } from '@/utils/check-ins/alerts-helpers'
import { ALERT_ENTITY_KEYS } from '@/utils/entity-keys'

import { transformWebhookName } from '@/views/workspaces/settings/integrations/integration-utils'

const triggersApi = new TriggersApiHandler()

class AlertsApiHandler extends ApiHandler {
  async fetchAlerts({ searchString = null, id = null } = {}) {
    const { data } = await triggersApi.fetchTriggers({ searchString, id })

    return data.map(alert => {
      return {
        ...alert,
        channels: alert.channels.map(channel => {
          return {
            ...channel,
            name: transformWebhookName(channel.name)
          }
        })
      }
    })
  }

  async checkIsCreateAlertAllowed() {
    const data = await this.fetchAlerts()

    return data.length < ALERTS_LIMIT
  }

  async createAlert(alert) {
    const { data } = await triggersApi.createTrigger({
      ...alert,
      [ALERT_ENTITY_KEYS.TYPE_ID]: ALERTS_TYPES.CHECKIN_CREATED
    })

    return data
  }

  async getAlertById({ id }) {
    const { data } = await triggersApi.getTriggerById({ id })

    return data
  }

  async updateAlert(alert) {
    const { data } = await triggersApi.updateTrigger(alert)

    return data
  }

  async deleteAlert({ id }) {
    return await triggersApi.deleteTrigger({ id })
  }
}

export default AlertsApiHandler
